<template>
  <div class="page-shop-on-shelves">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">門店上架</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="11" push="5">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>門店</span>
                </div>
                <Select
                  placeholder="選擇門店"
                  v-model="store_id"
                  @on-change="handleStoreChange"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in shopList"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>貨架號</span>
                </div>
                <!-- <Select v-model="form.arrive_code" placeholder="請選擇">
                                    <Option :value="item.id" v-for="(item, index) in shelvesList" :key="item.id">
                                        {{item.code}}
                                    </Option>
                                </Select> -->
                <Input
                  v-model="form.arrive_code"
                  ref="resetArrive"
                  @keyup.enter.native="onTab_order"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快遞單號</span>
                </div>
                <Input
                  v-model="form.odd_numbers"
                  ref="arrive_id"
                  @keyup.enter.native="onTab_confirm"
                ></Input>
              </FormItem>

              <FormItem>
                <div class="pg-btn-wrap">
                  <div
                    class="pg-btn style1"
                    ref="confirm_id"
                    @click="handleCheckForm"
                  >
                    確定
                  </div>
                  <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                </div>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";
export default {
  data() {
    return {
      line_audio:
        "https://jyb-admin-backend.aoyunltd.com/audio/change_shelf.mp3",
      err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/shelfonfail.mp3",
      suc_audio:
        "https://jyb-admin-backend.aoyunltd.com/audio/shelfonsuccess.mp3",

      // line_audio: "https://jyb-admin-backend.aoyunltd.com/audio/line.mp3",
      // err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
      // suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",

      shopList: [],
      store_id: Store.fetch().store_id,
      shelvesList: [], //货架号列表
      form: {
        arrive_code: "", //貨架號id,
        odd_numbers: "", //單號
      },
      isSubmiting: false,
    };
  },
  created() {
    this.pageParam = this.$route.query;
    if (this.pageParam.odd_numbers == undefined) {
      this.pageParam.odd_numbers = "";
    } else {
      this.form.odd_numbers = this.pageParam.odd_numbers;
    }
  },
  mounted() {
    this.getShopList();
    this.getShelvesList();
  },
  computed: {
    logInfo() {
      return this.$store.state.logInfo;
    },
  },
  methods: {
    onTab_order() {
      this.$refs.arrive_id.focus();
    },

    onTab_confirm() {
      if (this.store_id == 0) {
        this.$Utils.showTipInfo("請選擇門店");
        return;
      }

      if (
        this.form.odd_numbers.length == 1 ||
        this.form.odd_numbers.length == 2 ||
        this.form.odd_numbers.length == 3 ||
        this.form.odd_numbers.length == 4 ||
        this.form.odd_numbers.length == 5 ||
        this.form.odd_numbers.length == 6
      ) {
        let audio = new Audio();
        audio.src = this.line_audio;
        audio.play();
        this.$Utils.showTipInfo("貨架號已更改");
        this.$refs.resetArrive.focus();
        this.form.arrive_code = this.form.odd_numbers;
        this.form.odd_numbers = "";
        this.$refs.arrive_id.focus();
      } else if (this.form.odd_numbers.length == 0) {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      } else {
        this.$refs.confirm_id.focus();
        this.handleSubmit();
      }
      // this.handleSubmit();
    },
    //获取门店
    getShopList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 1, //type 1門店， 2是智能櫃
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.shopList = res.data.data.filter(it=>it.company_id != 15);;
          }
        });
    },
    handleStoreChange() {
      // this.getShelvesList();
    },
    getShelvesList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.shelvesList,
          method: "get",
          data: {
            store_id: this.store_id,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.shelvesList = res.data.data;
          }
        });
    },
    handleCheckForm() {
      let form = this.form;
      if (this.store_id == 0) {
        this.$Utils.showTipInfo("請選擇門店");
        return;
      } else if (!form.arrive_code) {
        this.$Utils.showTipInfo("請選擇貨架號");
        return;
      } else if (form.odd_numbers === "") {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }

      if (form.odd_numbers.length <= 6) {
        let audio = new Audio();
        audio.src = this.line_audio;
        audio.play();
        this.$Utils.showTipInfo("貨架號已更改");
        this.$refs.resetArrive.focus();
        this.form.arrive_code = this.form.odd_numbers;
        this.form.odd_numbers = "";
        // setTimeout(function() {
        this.$refs.arrive_id.focus();
        // },200)
      } else if (this.form.odd_numbers.length == 0) {
        this.$Utils.showTipInfo("請輸入貨架號");
        return;
      } else {
        this.$refs.confirm_id.focus();
        // this.handleStockScan(this.form.odd_numbers);
        this.handleSubmit();
      }
    },
    handleStockScan(goods) {
      this.$Rq
        .requestAuth({
          url: this.$Api.stockscanIn,
          method: "post",
          data: {
            odd_numbers: goods,
          },
        })
        .then((res) => {})
        .catch((err) => {});
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;

      this.handleStockScan(this.form.odd_numbers);

      this.$Rq
        .requestAuth({
          url: this.$Api.shopOnShelves,
          method: "post",
          data: {
            arrive_code: form.arrive_code, // Number(form.arrive_code)
            odd_numbers: form.odd_numbers,
            store_id: this.store_id,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          this.form.odd_numbers = "";
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
            let audio = new Audio();
            audio.src = this.suc_audio;
            audio.play();
          } else {
            this.$Utils.showTipInfo(res.msg);
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
          this.form.odd_numbers = "";
          let audio = new Audio();
          audio.src = this.err_audio;
          audio.play();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "ShopOnShelves.scss";
</style>
